import React from 'react'
import { Box, Typography } from '@mui/material'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'

const ContactUs = () => {
  return (
    <Box sx={{
      mt: 10,
      px: {
        xs: 2,
        md: 5,
        lg: 5
      },
      mb: {
        xs: 0,
        md: 5,
        lg: 10
      },
      display: "flex",
      height: "50vh",
    }}>

      <Box sx={{mx:"auto", my:"auto"}}>

        <Typography variant="h4" sx={{ maxWidth: 650, mb: 2 }}><span style={{ fontWeight: "bold" }}>AMBER MODE (M) SDN BHD (1109469-M) <br /> </span> Lot G-77, Wangsa Walk Mall, <br />Wangsa Avenue, <br />No.9, Jalan Wangsa Perdana 1, <br />Bandar Wangsa Maju, <br />53300 Kuala Lumpur, <br />Malaysia</Typography>
        <Typography
          variant="h4"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <LocalPhoneIcon sx={{ mr: 1 }} />
          +60 17228 2072
        </Typography>

      </Box>

    </Box>
  )
}

export default ContactUs